
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import background from '../assets/img/code.jpg';
import { useMst } from "../models";

const Code = () => {
  const [codeResult, setCodeResult] = useState();
  const { user, step } = useMst();
  const navigate = useNavigate();

  useEffect(() => {

  }, [])

  return (
    <div className="wrapper" style={{ height: '100vh' }}>
        <pre style={{ padding: '10px', whiteSpace: 'pre-wrap', overflow: 'auto' }}>{`
  지음과깃듬(이하 “회사”)은 회사가 운영하는 인터넷 사이트(www.icru.co.kr, 이하 “ICRU기질진단”)를 이용하는 이용자님들의 개인정보를 매우 중요하게 생각하며 아래와 같은 개인정보처리방침을 가지고 있습니다.

  이 개인정보처리방침은 개인정보와 관련한 법령 또는 지침의 변경이 있는 경우 갱신되고, 지음과깃듬 정책의 변화에 따라 달라질 수 있으니 이용자께서는 사이트를 방문시 수시로 확인하여 주시기 바랍니다. 회사의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.

  •	- 1. 개인정보의 수집·이용
  •	- 2. 개인정보 제3자 제공
  •	- 3. 개인정보 처리위탁
  •	- 4. 이용자 개인정보의 보유 ： 이용기간 및 파기
  •	- 5. 스마트폰 앱 관리
  •	- 6. 쿠키(Cookie)의 운용 및 거부
  •	- 7. 이용자의 권리
  •	- 8. 이용자의 의무
  •	- 9. 링크 사이트에 대한 책임
  •	- 10. 개인정보의 기술적／관리적 보호 대책
  •	- 11. 개인위치정보의 처리
  •	- 12. 개인정보 보호책임자 및 위치정보 관리책임자
  •	- 13. 고지의 의무

  지음과깃듬 개인정보처리방침

  개인정보처리방침
  1. 개인정보의 수집·이용
  가. 회사가 개인정보를 수집하는 목적은 이용자의 신분과 서비스 이용의사를 확인하여 최적화되고 맞춤화된 서비스를 제공하기 위함입니다. 회사는 최초 회원가입 시 서비스의 본질적 기능을 수행하기 위해 반드시 필요한 최소한의 정보만을 수집하고 있으며 회사가 제공하는 서비스 이용에 따른 대금결제 및 환불 등에 필요한 정보를 추가로 수집할 수 있습니다.

  나. 회사는 개인정보를 수집·이용·연구목적 이외에 다른 용도로 이를 이용하거나 이용자의 동의 없이 제3자에게 이를 제공하지 않습니다.

  다. 회사는 다음과 같은 목적으로 개인정보를 수집하여 이용할 수 있습니다. 다만, 전자상거래 등에서의 소비자보호에 관한 법률, 국세기본법, 전자금융거래법, 특정 금융거래정보의 보고 및 이용 등에 관한 법률 등 관계법령에 따라 주민등록번호 및 은행계좌번호의 수집·보관이 불가피한 경우나, 휴대폰 소액결제 등 요금정산을 위하여 이동전화번호정보의 수집·보관이 불가피한 경우에는 이용자에게 고지하여 해당 정보를 수집할 수 있습니다.

  1) 구매회원/판매회원
  목적	항목
  회원	본인여부 확인, 연령제한서비스 제공, SSO연동, 계약이행 및 약관변경 등의 고지를 위한 연락, 본인의사확인 및 민원 등의 고객불만처리	이름, ID, 비밀번호, 휴대폰번호, 이메일 주소, 외국인등록번호(외국인인 경우)
  주문, 결제서비스	이름, 전화번호, 주소, 은행계좌정보, 휴대폰결제 시 휴대폰번호, 현금영수증 신청 시 현금영수증 정보
  (새벽/휴일 배송 서비스 이용 시)
  공동현관 출입번호, 택배함 출입정보(출입번호, 택배함번호), 배송완료 사진
  맞춤형 서비스 제공, 서비스 이용 실적 통계·분석 및 설문을 통한 신규 서비스 개발 및 품질 개선	이름, ID, 서비스 이용기록, 기기정보
  마케팅 목적의 혜택 정보 제공	이름, ID, 성별, 생년월일, 휴대폰번호, 이메일 주소, 서비스 이용기록, 기기정보
  본인인증 식별, 본인여부, 연령 확인, 부정이용 방지, 맞춤형 서비스 제공, 서비스 이용 실적 통계·분석 및 설문을 통한 신규서비스 개발 및 품질 개선, 통합 서비스운영(*본인인증 시)	이름, 성별, 생년월일, 휴대폰번호, CI/DI, 아이핀 인증결과, 통신사, 내/외국인정보, 서비스이용기록, 기기정보, G통장 비밀번호(외국인 셀러)
  진단 서비스 고도화 및 연구개발을 목적으로 한 진단결과 수집	출생연도, 성별,직급,질문항목에 대한 답변
  (특정 개인을 알아볼 수 없는 형태로 가공)
  카카오 간편가입	이름(kakao 닉네임), 휴대폰번호(kakao 계정), CI
  Apple 간편가입	이름, 휴대폰번호, 이메일주소, 아이디
  특정금융거래정보의 보고 및 이용 등에 관한 법률에 따른 고객확인 의무	이름, 성별, CI, 국적, 생년월일, 휴대폰번호, 이메일, 계좌번호, 계좌주명, 직업 또는 업종, 여권번호(외국인)
  (강화된 고객확인 의무 수행 시)
  주민등록번호, 운전면허번호 또는 외국인등록번호, 직업 또는 업종, 거래목적, 자금 원천 정보, 실지명의자 확인을 위한 서류정보


  2) 부가서비스 및 맞춤식 서비스 이용 또는 이벤트 응모 과정에서 해당 서비스의 이용자에 한하여 추가적인 정보가 수집될 수 있습니다.
  구분	항목	목적	보유기간
  예정  	본인확인정보(CI)	멤버십 회원정보 관리, 멤버십 서비스 및 혜택 제공, 제휴사 회원 연동, 부정이용 방지, 서비스 이용고지	멤버십 탈퇴 시
  이름, ID		회원 탈퇴 시


  3) 제휴서비스
  회사는 제휴서비스 제공의 목적으로 제휴사를 통해 개인정보를 추가 수집하게 되는 경우 별도 이용자의 동의를 얻어 수집합니다.

  4) 기타
  서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집·저장·조합·분석될 수 있습니다.
  - 서비스 이용기록(IP Address, 쿠키, 방문 일시 등) 및 기기 정보(단말기식별번호, OS정보 등) 등 이용내역정보: 부정 이용 방지, 비인가 사용 방지, 신규 서비스 개발 및 맞춤서비스 제공 등

  라. 회사는 이용자의 개인정보를 수집할 경우 법령상 근거가 없는 한 반드시 이용자의 동의를 얻어 수집하며, 이용자의 기본적 인권을 침해할 우려가 있는 인종, 출신지, 본적지, 사상, 정치적 성향, 범죄기록, 건강상태 등의 정보는 이용자의 동의 또는 법령의 규정에 의한 경우 이외에는 수집하지 않습니다.

  마. 회사는 회원 가입을 만 14세 이상인 경우에 가능하도록 하며 개인정보의 수집·이용에 법정대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않습니다. 단, 법정대리인의 동의를 얻은 경우에는 만 14세 미만 이용자의 개인정보를 수집·이용할 수 있습니다.

  바. 회사는 다음과 같은 방법으로 개인정보를 수집할 수 있습니다.
  1) 홈페이지, 서면, 전화, 고객센터 문의하기, 이벤트 응모
  2) 생성정보 수집 툴을 통한 자동 수집

  사. 회사는 개인정보를 수집함에 있어, 서비스 제공에 필요한 최소한의 개인정보를 ‘필수동의 항목’으로, 그 외 개인정보는 ‘선택동의 항목’으로 구분하여 이에 대해 개별적으로 동의할 수 있는 절차를 마련합니다. 회사는 이용자가 필요한 최소한의 개인정보 이외의 개인정보를 제공하지 아니한다는 이유로 그 서비스의 제공을 거부하지 않습니다.

  2. 개인정보 제3자 제공
  가. 회사는 원칙적으로 이용자의 사전 동의를 받아 이용자들의 개인정보를 외부에 제공합니다. 다만, 아래의 경우에는 예외로 합니다.
  1) 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우
  2) 요금 정산을 위하여 필요한 경우
  3) 이용자 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요함에도 불구하고 동의를 받을 수 없는 경우

  나. 회사는 원칙적으로 「개인정보의 수집·이용」에서 고지한 범위 내에서 개인정보를 이용하거나 제3자에게 제공하며, 동 범위를 초과하여 이용하거나 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
  1) 이용자들이 사전에 공개 또는 제3자 제공에 동의한 경우
  2) 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우

  다. 그 밖에 개인정보 제3자 제공이 필요한 경우에는 이용자의 동의를 얻는 등 적법한 절차를 통하여 제3자에게 개인정보를 제공할 수 있습니다. 회사는 이용자들의 거래 이행을 위하여 필요한 경우 이용자의 동의를 얻는 등 적법한 절차를 통하여 아래와 같이 개인정보를 제공할 수 있습니다.

  1)개인정보 국내처리 위탁현황
  추후 수탁업체 계약 후 기재 예정
  수탁업체	위탁업무 내용
  추후 예정	-

  4. 이용자 개인정보의 보유 ： 이용기간 및 파기
  회사는 이용자의 개인정보를 원칙적으로 고지 및 약정한 기간 동안 보유 및 이용하며 개인정보의 수집 및 이용목적이 달성되거나 이용자의 파기 요청이 있는 경우 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다

  가. 관계법령 및 회사 방침에 의한 정보보유 사유
  상법 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 규정한 바에 따라 이용자의 개인정보를 보관하며 마케팅 등 다른 목적으로 이용하지 않습니다.

  1)관계법령에 따른 정보보유 사유
  관계 법률	목적	수집항목	보유기간
  통신비밀보호법	법원의 영장을 받아 수사기관이 요청시 제공	로그기록, IP 등	3개월
  전자상거래등에서의 소비자보호에 관한 법률	소비자의 불만 또는 분쟁처리에 관한 기록	소비자 식별정보,분쟁처리 기록 등	3년
  대금결제 및 재화 등의 공급에 관한 기록	소비자 식별정보,계약/청약철회 기록 등	5년
  계약 또는 청약철회 등에 관한 기록
  부가가치세법	장부, 세금계산서, 수입세금계산서, 영수증 등	부가가치세의 과세표준과 세액의 신고자료 등	5년
  전자금융거래법	전자금융거래기록 확인	전자금융거래에 관한 기록, 상대방에 관한 정보 등	5년
  특정 금융거래정보의 보고 및 이용 등에 관한 법률	고객확인 의무	고객확인 정보 등	5년

  2)회사방침에 의한 정보보유 사유
  - 부정거래기록
  보존 이유 : 부정거래의 배제
  보존 기간 : 1년
  보존 항목 : 이름, ID, CI/DI, 휴대폰번호, 이메일주소, 생년월일

  * 부정거래 : 법령, 회사와 이용자 간의 서비스 이용 약관 또는 공서양속을 위반하거나 기타 회사, 회원 또는 타인의 권리나 이익을 침해하는 방법이나 내용의 거래를 말함

  나. 수집된 개인정보의 보유·이용기간은 서비스이용계약체결(회원가입)시부터 서비스이용계약해지(탈퇴신청, 직권탈퇴 포함)입니다. 또한 동의 해지 시 회사는 이용자의 개인정보를 상기 명시한 정보보유 사유에 따라 일정 기간 저장하는 자료를 제외하고는 지체 없이 파기하며 개인정보처리가 제3자에게 위탁된 경우에는 수탁자에게도 파기하도록 지시합니다.

  다. 2015년 8월 18일부터, 회사는 1년 동안 회사의 서비스를 이용하지 않은 이용자의 개인정보는 ‘개인정보 보호법 제39조의6’ 에 근거하여 이용자에게 사전통지하고 개인정보를 파기하거나 별도로 분리하여 저장 관리합니다. 이용자의 요청이 있을 경우에는 위 기간을 달리 정할 수 있습니다. 단, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률 등의 관계법령의 규정에 의하여 보존할 필요가 있는 경우 관계법령에서 규정한 일정한 기간 동안 이용자 개인정보를 보관합니다

  라. 회사는 다항 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장·관리되는 사실과 기간 만료일 및 해당 개인정보의 항목을 공지사항, 전자우편 등의 방법으로 이용자에게 알립니다. 이를 위해 이용자는 회사에 정확한 연락처 정보를 제공/수정하여야 합니다.

  마. 파기방법
  이용자의 개인정보는 수집 및 이용목적이 달성된 후에는 지체 없이 파기됩니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각 등을 통하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법 또는 물리적 방법을 사용하여 파기합니다
  5. 스마트폰 앱 관리
  스마트폰 앱을 통해 서비스 이용 시, 이용자에게 개인정보 수집·이용 동의를 받은 범위 내에서 단말기정보 등에 접근한다는 것을 고지하고 승인을 획득한 후 정보가 수집되거나 전송됩니다. 앱 상에서 이용자가 단말기 접근 권한을 허용하였다고 하여 허용권한과 관련된 모든 정보가 즉시 수집되거나 전송되는 것은 아닙니다.서비스 제공을 위하여 스마트폰 앱의 접근 권한을 필수 또는 선택적으로 이용자에게 요청하고 있으며, 단말기 내 "설정" 메뉴를 통하여 이용자가 직접 권한을 변경할 수 있습니다. 앱 권한에 대한 자세한 사항은 애플리케이션 스토어를 통해 확인하실 수 있습니다.

  스마트폰 상에서 앱을 삭제하더라도 이용자의 회원계정은 유지되므로, 회원탈퇴를 원하실 경우 G마켓 앱 또는 PC 웹페이지 상에서 “회원탈퇴” 기능을 이용하시거나 고객센터(8ismlab@naver.com)로 연락하여 주시기 바랍니다.
  6. 쿠키(Cookie)의 운용 및 거부
  가. 쿠키의 사용 목적
  1) 회사는 회사가 운영하는 인터넷 사이트에서 개인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하는 ‘쿠키(cookie)’를 사용합니다. 쿠키는 웹사이트 서버가 이용자의 브라우저에게 전송하는 소량의 정보로서 이용자 컴퓨터의 하드디스크에 저장됩니다.
  2) 회사는 쿠키의 사용을 통해서만 가능한 특정된 맞춤형 서비스를 제공할 수 있습니다.
  3)회사는 회원을 식별하고 회원의 로그인 상태를 유지하기 위해 쿠키를 사용할 수 있습니다.

  나. 쿠키의 설치/운용 및 거부
  1) 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 조정함으로써 모든 쿠키를 허용/거부하거나, 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다.
  - 쿠키 설치 허용 여부를 지정하는 방법은 다음과 같습니다.
  o Internet Explorer를 사용하는 경우 (보기)
  o Microsoft Edge를 사용하는 경우 (보기)
  o Safari를 사용하는 경우 (보기)
  o FireFox를 사용하는 경우 (보기)
  o Chrome를 사용하는 경우 (보기)
  2) 쿠키의 저장을 거부할 경우에는 개인 맞춤서비스 등 회사가 제공하는 일부 서비스는 이용이 어려울 수 있습니다.
  3) 회사는 '온라인 맞춤형 광고 개인정보보호 가이드 라인'에 따라 이용자의 권리보호를 위한 페이지를 제공합니다. 맞춤형 광고에 대한 상세내용은 링크를 통해 확인하시기 바랍니다.
  7. 이용자의 권리
  가. 이용자는 언제든지 회사 사이트의 “정보수정”을 통하여 회원님의 개인정보를 열람, 정정 처리하실 수 있으며, 전자우편 또는 서면으로 요청하신 경우 열람, 정정, 삭제처리 해드리겠습니다. 이용자의 개인정보가 제3자에게 제공되거나 처리위탁된 경우 이용자는 회사 또는 ‘제3자’/’수탁자’에게 파기를 요청할 수 있습니다. 단, 회원 아이디(ID), 성명, 주민등록번호, 외국인등록번호는 정정이 불가능하며, 개명으로 인한 성명 변경 및 행정상의 문제로 인한 주민(사업자)등록번호 변경은 예외적으로 허용 될 수 있습니다. 기타 법률에 따라 정정 또는 삭제가 금지되거나 제한되어 있는 경우에는 해당 처리가 제한될 수 있습니다. 또한 개인정보 오류에 대한 정정 요청한 경우에는 다른 법률에 따라 개인정보의 제공을 요청받는 경우가 아닌 한 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다, 만약 잘못된 개인정보를 이미 제공한 경우에는 정정 처리 결과를 제 3자에게 통지하여 정정이 이루어지도록 하겠습니다.

  나. 이용자는 언제든지 회사 사이트의 개인정보에 대하여 처리의 정지를 요구 할 수 있습니다. 다만 아래의 경우에 해당하는 경우 처리정지 요구를 거절할 수 있습니다.
  1) 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
  2) 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
  3) 개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우

  다. 회원가입 등을 통해 개인정보의 수집·이용·제공에 대해 회원님께서 동의하신 내용을 언제든지 철회할 수 있습니다. 동의철회는 회사 사이트 내 “회원 탈퇴 신청”을 클릭하거나 서면, 이메일 등으로 연락하시면 지체 없이 개인정보의 삭제 등 필요한 조치를 하겠습니다. 다만 법률 또는 약관의 규정에 따라 회사가 회원님의 개인정보를 보존하여야 하는 경우에는 해당 처리가 제한될 수 있습니다. 이 경우 회원님은 본인 식별을 위하여 반드시 회원아이디(ID)와 본인확인 식별정보를 밝히셔야 하며, 철회로 인해 서비스에 다소 제약이 있거나 일부 서비스를 이용하지 못하실 수 있습니다
  8. 이용자의 의무
  이용자는 자신의 개인정보를 보호할 의무가 있으며, 회사의 귀책사유가 없이 ID, 비밀번호, 접근매체 등의 양도·대여·분실이나 로그인 상태에서 이석 등 이용자 본인의 부주의나 관계법령에 의한 보안조치로 차단할 수 없는 방법이나 기술을 사용한 해킹 등 회사가 상당한 주의에도 불구하고 통제할 수 없는 인터넷 상의 문제 등으로 개인정보가 유출되어 발생한 문제에 대해 회사는 책임을 지지 않습니다.

  가. 이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의 부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게 있습니다.

  나. 타인의 개인정보를 도용한 회원가입 또는 ID 등을 도용하여 결제처리 시 이용자자격 상실과 함께 관계법령에 의거하여 처벌될 수 있습니다.

  다. 이용자는 ID, 비밀번호 등에 대해 보안을 유지할 책임이 있으며 제3자에게 이를 양도하거나 대여할 수 없습니다. 이용자는 회사의 개인정보보호정책에 따라 보안을 위해 비밀번호의 주기적 변경에 협조할 의무가 있습니다.

  라. 이용자는 회사의 서비스를 이용한 후에는 반드시 로그인 계정을 종료하고 웹 브라우저 프로그램을 종료해야 합니다.

  마. 이용자는 "정보 통신망 이용촉진 및 정보보호 등에 관한 법률", “개인정보보호법”, "주민등록법" 등 기타 개인정보에 관한 법률을 준수하여야 합니다.
  9. 링크 사이트에 대한 책임
  회사는 이용자에게 다른 웹사이트에 대한 링크를 제공할 수 있습니다. 다만, 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "개인정보처리방침"이 적용되지 않습니다.
  10. 개인정보의 기술적／관리적 보호 대책
  회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 보호대책을 강구하고 있습니다.

  가. 개인정보 내부관리계획 수립 및 시행
  회사는 이용자의 개인정보를 처리함에 있어 안전하게 관리하고 보호할 수 있도록 개인정보 내부관리계획을 수립 및 시행하고 있습니다.

  나. 개인정보의 암호화
  이용자의 비밀번호는 일방향 암호화하여 저장 및 관리되고 있으며, 개인정보의 확인 및 변경은 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 비밀번호는 이용자의 생일, 전화번호 등 타인이 추측하기 쉬운 숫자 등을 이용하지 않도록 비밀번호 생성규칙을 수립하여 적용하고 있습니다. 주민등록번호, 외국인 등록번호, 은행계좌번호 및 신용카드번호 등의 개인정보는 안전한 암호 알고리즘으로 암호화되어 저장 및 관리되고 있습니다.

  다. 해킹 등에 대비한 대책
  회사는 해킹 등 회사 정보통신망 침입에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위해 침입탐지 및 침입차단 시스템을 24시간 가동하고 있습니다. 만일의 사태에 대비하여 모든 침입탐지 시스템과 침입차단 시스템은 이중화로 구성하여 운영하고 있으며, 민감한 개인정보는 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.

  라. 개인정보 취급자의 최소화 및 교육
  회사는 회사의 개인정보 취급자를 최소한으로 제한하며, 개인정보 취급자에 대한 교육 등 관리적 조치를 통해 개인정보보호의 중요성을 인식시키고 있습니다.

  마. 개인정보보호 전담부서의 운영
  회사는 개인정보의 효율적 보호를 위해 개인정보보호전담부서를 운영하고 있으며, 개인정보처리방침의 이행사항 및 개인정보 취급자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정할 수 있도록 노력하고 있습니다.

  바. 접속기록의 보관 및 위변조 방지 대책
  회사는 개인정보취급자가 개인정보처리시스템에 접속한 기록을 안전하게 보관·관리하고 있으며, 접속기록의 위조·변조·분실 등을 방지하기 위하여 주기적으로 접속기록을 점검하고 있습니다.
  11. 개인정보 보호책임자 및 위치정보 관리책임자
  회사는 이용자가 회사의 서비스를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 이용자는 회사의 서비스 이용과 관련한 모든 개인정보보호 민원을 전담부서로 신고하실 수 있으며, 회사는 이용자의 신고사항에 대해 신속하고 성실하게 답변해드리고 있습니다.


  개인정보 보호책임자 및
  위치정보 관리책임자
  성명 : 김여정
  전자우편 : 8ismlab@naver.com
  ※ 상기 연락처 등은 “개인정보보호 전담 고객센터” 입니다.


  기타 개인정보침해에 대한 신고 또는 상담이 필요하신 경우에는 아래 기관으로 문의하시기 바랍니다.


  개인정보분쟁조정위원회
  전화 : 1833-6972
  URL : http://www.kopico.go.kr
  개인정보침해신고센터
  전화 : (국번없이)118
  URL : http://privacy.kisa.or.kr
  대검찰청 첨단범죄수사센터
  전화 : (국번없이)1301
  URL : http://www.spo.go.kr
  경찰청 사이버안전국
  전화 : (국번없이)182
  URL : https://ecrm.police.go.kr/minwon/main


  13. 고지의 의무
  본 개인정보처리방침은 관계법령 및 지침의 변경 또는 회사의 필요 등에 의하여 내용의 추가, 삭제 및 수정이 생길 수 있습니다. 이 경우 최소 7일 전에 홈페이지 또는 이메일을 통해 사전 공지하고 사전 공지가 곤란한 경우 지체 없이 공지하며, 별도 공지가 없는 한 7일이 경과된 후에 시행됩니다. 다만, 중대한 내용이 변경되는 경우에는 최소 30일 전에 공지하고, 별도 공지가 없는 한 30일이 경과된 후에 시행됩니다. 또한 당사는 관계법령에 따라 필요한 경우 고객의 별도 동의를 받을 수 있습니다.
  공고일자 : 2022년 09월 23일
  시행일자 : 2022년 09월 30일
  고객 개인정보보호와 관련하여 의견이나 불만이 있으시면 개인정보보호책임자 및 담당자에게 문의하여 주십시오. 신속하고 정확하게 처리해 드리도록 하겠습니다.

  E-Mail : 8ismlab@naver.com
            `}</pre>
    </div>
  )
};

export default Code;